import AsyncStorage from '@callstack/async-storage'

import { SET_INITIAL_URL } from '../modules/url/actions'
import { setSignUpForm } from '../modules/session/actions'

export default store => next => action => {
  switch (action.type) {
    case SET_INITIAL_URL:
      bootstrapSession(store)
      next(action)
      break

    default:
      next(action)
  }
}

async function bootstrapSession (store) {
  let signUpForm = await AsyncStorage.getItem('signUpForm')

  if (signUpForm) {
    store.dispatch(setSignUpForm(
      JSON.parse(signUpForm)
    ))
  }
}
